import React from 'react'
import { useParams } from 'react-router-dom'
import { useState, useEffect } from 'react'
import axios from 'axios'
import { API_URL, BACK_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link, HashRouter } from 'react-router-dom';
import { fetchDetails, scrollToTop } from './Api';


export default function Pagedetail() {
    const { id } = useParams()

    const [page, setpage] = useState([])


    useEffect(() => {
        const fetchData = async ({ id }) => {
            const url = `${API_URL}/pagedetail/${id}`;
            const data = await fetchDetails(url);
            if (data) {
                setpage(data);
            }
            scrollToTop();
        };
        fetchData({ id });
    }, []);


    return (
        <>

            <main id="tg-main" className="tg-main tg-haslayout">

                <section className="tg-sectionspace tg-haslayout tg-bg" id="tg-about">
                    <div className="container">
                        <div className="row">
                            <div className="tg-aboutus">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                                    {/* {JSON.stringify(page)} */}

                                    {page.map(pag => (

                                        <div className="tg-sectionhead tg-textalignleft">
                                            <div className="tg-sectionheading">

                                                <h2>{pag.title}</h2>
                                            </div>
                                            <div className="tg-description">
                                                <div dangerouslySetInnerHTML={{ __html: pag.description }}></div>
                                            </div>

                                        </div>
                                    ))}


                                </div>

                            </div>
                        </div>
                    </div>
                </section>

            </main >
        </>
    )
}
